import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { affiliateDetailBank } from "../../../../stores/actions/affiliate.actions.types";
import { BiLoaderAlt } from "react-icons/bi";
import MetaHead from "../../../Common/Metahead";

const BankDetailsPage = ({ affiliateDetailBank, loading }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [bank, setBank] = useState(null);

  useEffect(() => {
    if (id) {
      affiliateDetailBank({
        id,
        callback: (data) => {
          if (data?.success) {
            setBank(data?.data?.payoutMethod);
          }
        },
      });
    }
  }, [id, affiliateDetailBank]);

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <BiLoaderAlt className='animate-spin text-4xl text-blue-600' />
      </div>
    );
  }

  if (!bank) {
    return (
      <div className='flex items-center justify-center min-h-screen text-gray-500'>
        No payout details found.
      </div>
    );
  }

  return (
    <>
      <MetaHead title='Affiliate Payout Details' />
      <div className='p-6 sm:p-10 dark:bg-gray-900 min-h-screen'>
        <div className=' mx-auto'>
          <div className='lg:col-span-2 bg-white dark:bg-gray-800 rounded-l-xl shadow p-6'>
            {bank.methodType === "bank" && (
              <Section title='Bank Information'>
                <Field
                  label='Account Holder Name'
                  value={bank.accountHolderName}
                />
                <Field label='Bank Name' value={bank.bankName} />
                <Field label='Branch Name' value={bank.branchName} />
                <Field label='Account Number' value={bank.accountNumber} />
                <Field label='Account Type' value={bank.accountType} />
                <Field label='Routing Number' value={bank.routingNumber} />
                <Field label='SWIFT Code' value={bank.swiftCode} />
                <Field label='Currency' value={bank.currency} />
              </Section>
            )}

            {bank.methodType === "paypal" && (
              <Section title='PayPal Information'>
                <Field label='PayPal Email' value={bank.paypalEmail} />
                <Field label='Currency' value={bank.currency} />
              </Section>
            )}

            {bank.methodType === "crypto" && (
              <Section title='Crypto Wallet Information'>
                <Field label='Cryptocurrency' value={bank.cryptoCurrency} />
                <Field label='Network' value={bank.network} />
                <Field
                  label='Wallet Address'
                  value={bank.cryptoWalletAddress}
                />
                <Field label='Currency' value={bank.currency} />
              </Section>
            )}

            <div className='mt-6'>
              <h4 className='text-sm font-medium text-gray-600 dark:text-gray-300 mb-2'>
                Status
              </h4>
              <div className='flex gap-2 flex-wrap'>
                <StatusBadge label='Primary' active={bank.isPrimary} />
                <StatusBadge label='Verified' active={bank.isVerified} />
              </div>
            </div>

            {bank?.notes && (
              <div className='mt-6'>
                <h4 className='text-sm font-medium text-gray-600 dark:text-gray-300 mb-1'>
                  Notes
                </h4>
                <p className='text-sm text-gray-700 dark:text-gray-300'>
                  {bank.notes}
                </p>
              </div>
            )}
          </div>

          {bank.methodType === "bank" && (
            <div className='bg-white dark:bg-gray-800 rounded-r-xl shadow p-6'>
              <Section title='Bank Address'>
                <Field label='Street' value={bank?.address?.street} />
                <Field label='City' value={bank?.address?.city} />
                <Field label='State' value={bank?.address?.state} />
                <Field label='Postal Code' value={bank?.address?.postalCode} />
                <Field label='Country' value={bank?.address?.country} />
              </Section>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const Section = ({ title, children }) => (
  <div className='mb-6'>
    <h3 className='text-lg font-semibold text-gray-800 dark:text-white mb-4'>
      {title}
    </h3>
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>{children}</div>
  </div>
);

const Field = ({ label, value }) => (
  <div>
    <div className='text-sm text-gray-500 dark:text-gray-400'>{label}</div>
    <div className='text-sm font-medium text-gray-900 dark:text-white'>
      {value || "—"}
    </div>
  </div>
);

const StatusBadge = ({ label, active }) => (
  <span
    className={`text-xs font-semibold px-3 py-1 rounded-full ${
      active
        ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300"
        : "bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300"
    }`}
  >
    {active ? label : `Not ${label}`}
  </span>
);

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, { affiliateDetailBank })(
  BankDetailsPage
);
